<template>
    <v-app id="inspire">

        <v-snackbar
                v-model="loginSnackbar"
                :timeout="snackbarTimeout"
                bottom
                color="success"
                class="text-center"
        >
            <v-spacer></v-spacer>
            Successfully Logged In
            <v-spacer></v-spacer>
        </v-snackbar>

        <v-snackbar
                v-model="logoutSnackbar"
                :timeout="snackbarTimeout"
                bottom
                color="success"
                class="text-center"
        >
            <v-spacer></v-spacer>
            Successfully Logged Out
            <v-spacer></v-spacer>
        </v-snackbar>

        <v-snackbar
                v-model="registerSnackbar"
                :timeout="snackbarTimeout"
                bottom
                color="success"
                class="text-center"
        >
            <v-spacer></v-spacer>
            Registration Successful
            <v-spacer></v-spacer>
        </v-snackbar>

        <v-snackbar
                v-model="addToDeckSnackbar"
                :timeout="500"
                top
                color="success"
                class="text-center"
        >
            <v-spacer></v-spacer>
            Card added to deck
            <v-spacer></v-spacer>
        </v-snackbar>

        <v-navigation-drawer v-model="drawer" app temporary>

            <v-list-item>
                <v-list-item-icon>
                    <v-img
                            src="./static/img/Redemption-Logo-Remastered-R-76x76-min.png"
                            lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAMAAADwSaEZAAAALVBMVEX/AABHcEz/AAD/AADeAAAkAAFuURwGAwLn2QLGtwc4HAGqmAyGdQ2BAAHGAACpilCxAAAABnRSTlP/AGi5LY/jUnJwAAADyElEQVRYw+2Y29LrIAiFU3Urivr+j7sF8dSmzGSml793TevXJeICc71+OK4/2OvlzKOhw+z1ZFgV5h6xLnf9UJgas6fCVJh5KEyFPRNmVNgzYZeeZ+t3tbRRz7klnU+MCjNzVpBRNhR9Tmf4NZhds0LyPm00ephyCPUIvwJza1aEGCNAFlolbgZIu1SnwpqwSigEzJ5GJtpEoY95W6dVD7rrLIRO6rQQKqF8Q3mPkdi7sK8wQ2tMEDHGOHjAW+EhyscVNKtbUPtFCggEynN2g6UGX+yy5cV3mGGYjARDSuKdENgWNN0cedcYRGkGEjMERAxj2StoRoVJwtaeHqIMITZcCBn9W9CcCtuNLI3ZGCPEHIJ/D5pVa8BuZHWtMvkItPQZNN+D5lTYKUyUtKmAmWEjaMhBs2p12oRRkspcCCyshIC4sngL/z3M7KiAXVgTFVlKClmCFnk7rV43d5/pR0eSjCM+dhfBswsZFWY2n4GR8FNY7XmHdOx5M/WKPjZR8j2v7E8hiWcA0vf1iNgdzCzLioAjYTFEyvh+0CHS92fC3sNsXyH/fRo7Byl1Ai98c12rNi6OV0hxz+DDEoYkjBfu93LgVJi9eE7m/Uq7MM9Wmad9fwj7gDneehyJJCcphoyQ+2MWfJ1G9gVmKGBxHBihxhRoM+RI4rJYqzd73RTzZv0iDNeTJq3cCXuHmWvQNhgf8bhocsDPhL2Bzco7nZ4TNkfICOiPA/4h7A1mpu8kOISRKaa59hE0p8LscsSIS5iYoocTZtVu2316NR9xoCiVZbGQQr0RdsLs1uUspydh5D3LYrsyq94D3HUDm97TYPGAGRVmDti7KZ6wz7x4gx1lRE7l8J66wTLbtVFhZms750TxHsr4+QwxpOvS70726DthtAAowmYBpTCmO2EbzOzdqjiERwDynpDKVn2p+FanwuxEZYi4TrmPkKUdWrAQ/mkwJ9Y/RW2uATEEkhOXshA02LJ+/zkiAGAYqRcxQgjuO8x1Wbcojh2u9ofKlgoz3A7HfM/KXEXmcY1UNZVlFpGVkZbEY3NDLm6jx+C+ICi7+Y+rG1I355NcSlAa40xmFuo4rtSu3O7lhFHHD5BnT9x5XFiQm+zRjuavsibMNJiQUimVR+8QMgsp0kIiV/Pi1FcRdoD2W1/tZWp2FSmkvmCrvtdw/MvycR8tx82wBrkXOhX29S1BCfs9sElNtw57wJTLcr29jCuw55dxBfb4LYEC+5kwgtlfCWsw8/QljQZ7+vZIg7nfCXtdPxT2up69CHR/r1Z/DPsPUbxCTww0tegAAAAASUVORK5CYII="
                            max-height="40"
                            max-width="40"
                            contain
                    ></v-img>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title class="title unselectable">
                        RedemptionDB
                    </v-list-item-title>
                    <v-list-item-subtitle class="font-weight-light text--disabled unselectable">
                        {{ version }}
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item v-if="!userLoggedIn">
                <v-btn block :color="specialNavColor" @click="redirectToLogin">sign in</v-btn>
            </v-list-item>


            <v-divider></v-divider>


            <v-list nav dense>

                <v-list-item-group
                        color="primary"
                        v-if="userLoggedIn"
                >
                    <v-list-item v-if="userLoggedIn">
                        <v-btn block :color="specialNavColor" @click="signOut">sign out</v-btn>
                    </v-list-item>

                    <v-list-item
                            to="/profile"
                            @click.stop="drawer = false"
                    >
                        <v-list-item-icon>
                            <v-icon>person</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Profile ({{ displayName }})</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-divider></v-divider>
                </v-list-item-group>

                <v-list-item-group
                        color="primary"
                >
                    <v-list-item
                            v-for="(item, index) in navbar_items"
                            :disabled="item.disabled"
                            :key="index"
                            :to="item.path"
                            @click.stop="drawer = false"
                    >
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>

            </v-list>
        </v-navigation-drawer>

        <v-app-bar app dense elevation="4">
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

            <!--            <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="!drawer" transition="scale-transition">-->
            <!--                <v-icon>menu</v-icon>-->
            <!--            </v-app-bar-nav-icon>-->
            <!--            <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="drawer" transition="scale-transition">-->
            <!--                <v-icon>clear</v-icon>-->
            <!--            </v-app-bar-nav-icon>-->

            <v-toolbar-title>{{ $router.currentRoute.name }}</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-switch
                    v-model="$vuetify.theme.dark"
                    color="secondary"
                    hide-details
            />

            <v-btn v-if="$router.currentRoute.path === '/cards' " @click="toggleCardDrawer" icon>
                <v-icon>filter_list</v-icon>
            </v-btn>
        </v-app-bar>

        <v-content>
            <v-container fluid fill-height class="scroll-y justify-center">
                <router-view></router-view>
            </v-container>
        </v-content>

        <v-btn
                id="upButtton"
                v-scroll="onScroll"
                v-show="fab"
                fab
                fixed
                bottom
                right
                @click="$vuetify.goTo(0)"
                color="secondary"
                elevation="24"
        >
            <v-icon>keyboard_arrow_up</v-icon>
        </v-btn>

        <v-footer
                app
                absolute
        >
            <v-col
                    id="footer"
                    readonly
                    class="font-weight-light text-center text--disabled"
                    cols="12"
            >Copyright &copy; {{ new Date().getFullYear() }} - Redemption is a registered trademark of <a
                    href="http://www.cactusgamedesign.com/" style="color:grey">Cactus
                Game
                Design.</a>, Inc. Card images are copyright Cactus Game Design, Inc. Used with permission.
            </v-col>
        </v-footer>
    </v-app>
</template>

<style>
    .unselectable {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    #footer {
        font-size: 8pt;
    }

    #upButtton {
        /*margin-bottom: 65px;*/
    }
</style>

<script>
    import {version} from "./version";

    export default {
        name: "App",
        data() {
            return {
                snackbarTimeout: 2000,
                version: version,
                fab: false,
                drawer: false,
                navbar_items: [
                    {title: 'Home', icon: 'dashboard', path: '/home', disabled: false},
                    {title: 'Cards', icon: 'crop_portrait', path: '/cards', disabled: false},
                    {title: 'Decks', icon: 'reorder', path: '/decks', disabled: false},
                    {title: 'Collections', icon: 'book', path: '/collections', disabled: true},
                    {title: 'Trading Post', icon: 'cached', path: '/trading', disabled: true},
                    {title: 'Resources', icon: 'library_books', path: '/resources', disabled: false},
                    {title: 'Settings', icon: 'settings', path: '/settings', disabled: true},
                    {title: 'About', icon: 'help', path: '/about', disabled: false},
                ],
            };
        },
        computed: {
            specialNavColor() {
                return this.$vuetify.theme.dark ? "grey darken-3" : "grey lighten-2";
            },
            user() {
                return this.$store.getters.user;
            },
            displayName() {
                let displayName = this.$store.getters.user.displayName;
                return displayName !== null ? displayName : "";
            },
            userLoggedIn() {
                return this.$store.getters.getIsUserLoggedIn;
            },
            loginSnackbar: {
                get() {
                    return this.$store.getters.getLoginSnackbar;
                },
                set(value) {
                    this.$store.commit('setLoginSnackbar', value);
                },
            },
            logoutSnackbar: {
                get() {
                    return this.$store.getters.getLogoutSnackbar;
                },
                set(value) {
                    this.$store.commit('setLogoutSnackbar', value);
                },
            },
            registerSnackbar: {
                get() {
                    return this.$store.getters.getRegistrationSnackbar;
                },
                set(value) {
                    this.$store.commit('setRegisterSnackbar', value);
                },
            },
            addToDeckSnackbar: {
                get() {
                    return this.$store.getters.getAddToDeckSnackbar;
                },
                set(value) {
                    this.$store.commit('setAddToDeckSnackbar', value);
                },
            }
        },
        methods: {
            onScroll(e) {
                if (typeof window === 'undefined') return;
                const top = window.pageYOffset || e.target.scrollTop || 0;
                this.fab = top > 300;
            },
            redirectToLogin() {
                this.$router.push({path: '/login'});
            },
            signOut() {
                this.drawer = false;
                this.$store.dispatch("signOutUser");

            },
            toggleCardDrawer() {
                this.$store.dispatch('toggleFilterDrawer');
            }
        },
        created() {
            this.$store.dispatch("initializeCardData");
            if (this.$store.getters.getIsUserLoggedIn && !this.$store.getters.getIsUserDataLoaded()) {
                this.$store.dispatch("downloadUserData", this.$store.getters.user.uid);
            }
        }
    };
</script>
